import { useMemo } from "react";

import { match } from "ts-pattern";

import SnowflakeLogoSourceIconDark from "../../assets/components/sources/SnowflakeLogoSourceIconDark";
import SnowflakeLogoSourceIconLight from "../../assets/components/sources/SnowflakeLogoSourceIconLight";
import { GalaxyTheme } from "../../theme/constants";
import { useGalaxyTheme } from "../../theme/GalaxyTheme";

const SnowflakeLogomark = ({ height }: { height: number }) => {
  const { galaxyTheme } = useGalaxyTheme();

  const logo = useMemo(() => {
    return match(galaxyTheme)
      .with(GalaxyTheme.DARK, () => <SnowflakeLogoSourceIconLight height={height} />)
      .with(GalaxyTheme.LIGHT, () => <SnowflakeLogoSourceIconDark height={height} />)
      .exhaustive();
  }, [galaxyTheme, height]);

  return logo;
};

export default SnowflakeLogomark;
